module.exports = __webpack_public_path__ + "assets/apple-touch-icon-120-prod-c5e161.png";